import React from 'react'
import classnames from 'classnames'
import Toggle from '../../../../shared/Toggle'
import LayersIcon from '../../../common/icons/LayersIcon'
import SilhouetteIcon from '../../../common/icons/SilhouetteIcon'
import {VIEW_MODES} from '../../constants/editorConfig'
import Icon from '../../../common/Icon'

const VIEW_OPTIONS = [
    {
        value: VIEW_MODES.SILHOUETTE,
        label: 'Silhouette View',
        icon: <Icon icon={SilhouetteIcon} />,
    },
    {
        value: VIEW_MODES.OVERLAY,
        label: 'Overlay View',
        icon: <Icon icon={LayersIcon} />,
    },
]

/**
 * View toggle: Silhouette View | Overlay View. Built on shared Toggle.
 *
 * @param {string} value - VIEW_MODES.SILHOUETTE | VIEW_MODES.OVERLAY
 * @param {function(string): void} onChange
 * @param {string} [className]
 */
const ViewToggle = ({value, onChange, className}) => (
    <Toggle
        className={classnames('ViewToggle', className)}
        name="View mode"
        options={VIEW_OPTIONS}
        value={value}
        onChange={onChange}
    />
)

export default ViewToggle
